import { render, staticRenderFns } from "./NotificationApps.vue?vue&type=template&id=d936f6da&scoped=true&"
import script from "./NotificationApps.vue?vue&type=script&lang=js&"
export * from "./NotificationApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d936f6da",
  null
  
)

export default component.exports